import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { ToastContext, useFetch } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'
import configurationServices from '@/configuration/services/services'

import { transformResponseRequestSmartTracking } from './transformers'

const useSmartTrackingRequest = () => {
  const { t } = useTranslation()
  const { info, updateContext } = useContext(AppContext)
  const { setToastInfo } = useContext(ToastContext)

  const { fetchData, loading } = useFetch(configurationServices.requestSmartTracking, {
    doInitialRequest: false,
    transformResponse: transformResponseRequestSmartTracking,
  })

  const requestSmartTracking = async () => {
    try {
      const smartTracking = await fetchData()

      updateContext(context => ({ ...context, smart_tracking_requested: smartTracking.smart_tracking_requested }))
    } catch {
      setToastInfo({
        show: true,
        message: t('Ha ocurrido un error al solicitar Smart Tracking. Inténtalo de nuevo.'),
        type: 'error',
      })
    }
  }

  return {
    smartTrackingRequested: Boolean(info.smart_tracking_requested),
    requestSmartTracking,
    requestingSmartTracking: loading,
  }
}

export default useSmartTrackingRequest
